"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.screenSize = void 0;
exports.screenSize = {
    sm: '@media all and (max-width: 768px) and (max-resolution: 4dppx), all and (max-width: 768px) and (-webkit-max-device-pixel-ratio: 4)',
    ms: '@media all and (max-width: 1070px) and (max-resolution: 4dppx), all and (max-width: 1070px) and (-webkit-max-device-pixel-ratio: 4)',
    md: '@media all and (max-width: 1250px) and (max-resolution: 4dppx), all and (max-width: 1250px) and (-webkit-max-device-pixel-ratio: 4)',
};
